export const NavBrand = ({ onClick }) => {
  return (
    <a href onClick={onClick} className="navbar-brand page-scroll">
      <img src="img/Al-Madani Masjid.svg" className="header-img" alt="Al-Madani Masjid" />
    </a>
  );
};
